import { tableExtension as tableExtensionBase } from '@copera/tiptap/extensions';
import { tableCellExtension } from './tableCell';
import { tableHandleExtension } from './tableHandle';
import { tableHeaderExtension } from './tableHeader';
import { tableRowExtension } from './tableRow';

export const tableExtension = tableExtensionBase
  .extend({
    allowGapCursor: false,

    addExtensions() {
      return [
        tableRowExtension,
        tableHeaderExtension,
        tableCellExtension,
        tableHandleExtension,
      ];
    },

    addCommandOption() {
      return [
        {
          title: 'Add Table',
          icon: 'tabler:table',
          description: 'Add a table to the document',
          searchTerms: ['table', 'add table', 'insert table'],
          command({ editor, range }) {
            editor
              .chain()
              .focus()
              .deleteRange(range)
              .insertTable({
                rows: 3,
                cols: 3,
                withHeaderRow: true,
              })
              .run();
          },
        },
      ];
    },
  })
  .configure({
    cellMinWidth: 110,
    resizable: true,
  });
